/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

interface UiButtonFilterProps {
    active?: boolean;
    className?: string;
    title?: string;
    icon?: React.ReactNode | React.ReactNode[];
    onClick?: (e: any) => void;
    disabled?: boolean;
    disabledStyle?: boolean;
}

const UiFilterButton = (props: UiButtonFilterProps) => {
    const {t} = useTranslation();

    return (
        <button
            className={clsx(
                "UiButtonFilter first-of-type:rounded-tl first-of-type:rounded-bl last-of-type:rounded-tr last-of-type:rounded-br inline-flex items-center px-5 py-2 border text-sm font-medium transition duration-150",
                props.className && props.className,
                props.active
                    ? "bg-gray-200 border-gray-500 text-blue-400 cursor-default"
                    : "bg-white hover:bg-blue-400 border-gray-500 hover:border-blue-400 text-gray-800 hover:text-white",
                props.disabled && "pointer-events-none cursor-not-allowed",
                props.disabledStyle && "text-gray-800/50"
            )}
            disabled={props.disabled}
            type={"button"}
            onClick={e => props.onClick ? props.onClick(e) : undefined}
        >
            <span>{props.title}</span>
            {props.icon && props.icon}
        </button>
    );
};

export default UiFilterButton;
